import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import { useHistory } from "@NA/Hooks/useHistory";
import FooterAppIcon from "@NA/Icons/FooterAppIcon";
import FooterBranchIcon from "@NA/Icons/FooterBranchIcon";
import FooterChatIcon from "@NA/Icons/FooterChatIcon";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => {
    const billToId = state.context.session.billToId;
    let livechat_accountNumber;
    if (billToId) {
        livechat_accountNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }

    return {
        liveChatURL: getSettingsCollection(state).customerSettings.liveChatURL,
        deviceType: state.context.session.deviceType,
        isAuthenticated: state.context.session.isAuthenticated,
        livechat_firstName: state.context.session.firstName,
        livechat_lastName: state.context.session.lastName,
        livechat_email: state.context.session.email,
        billToCustomerNo: state.context.session.billToId,
        livechat_accountNumber,
    };
};

const mapDispatchToProps = {
    toggleLoginDrawer,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ADIFooterBarStyles {
    footerBarContainer?: InjectableCss;
    footerImages?: TextFieldProps;
    SignUpforEmail?: TypographyProps;
    text1?: TypographyProps;
    text2?: TypographyProps;
    signUpWrapper?: InjectableCss;
    emailTextBoxWrapper?: InjectableCss;
    text3?: TypographyProps;
    text4?: TypographyProps;
    text5?: TypographyProps;
    textDisplay?: TypographyProps;
    text6?: TypographyProps;
    text7?: InjectableCss;
    text8?: TypographyProps;
    text9?: ImgProps;
    text10?: ImgProps;
    text11?: ImgProps;
    branchIocn?: ImgProps;
    vectorMessage?: ImgProps;
    vectorChat?: ImgProps;
    needAssistance?: TypographyProps;
    downloadchatwithus?: TypographyProps;
    mondayTofridayText?: TypographyProps;
    downloadchatwithusTab?: TypographyProps;
    mobileIcons?: TypographyProps;
    outlineButton?: TypographyProps;
    signUpText?: TypographyProps;
    chatWithUs?: TypographyProps;
    signupButton?: TypographyProps;
    needAssistanceBottomText?: TypographyProps;
    container?: GridContainerProps;
    linksGridContainer?: GridItemProps;
    iconsGridContainer?: GridItemProps;
    tabLeftContainer?: InjectableCss;
    signUpTabWrapper?: InjectableCss;
    emailTextBoxTabWrapper?: InjectableCss;
    chatWithUsTab?: InjectableCss;
    emailtextBoxTab?: InjectableCss;
    tabContainer?: InjectableCss;
    tabRightContainer?: InjectableCss;
    signupTextTab?: InjectableCss;
    tabBranchlocContainer?: InjectableCss;
    tabDownloadAppContainer?: InjectableCss;
    tabChatWithUsContainer?: InjectableCss;
    tabfootertext?: InjectableCss;
    tabfooterchattext?: InjectableCss;
    emailErrorText?: InjectableCss;
}

export const adiFooterBarStyles: ADIFooterBarStyles = {
    footerImages: {
        cssOverrides: {
            formField: css`
                ${FormInputWrapper} {
                    input {
                        width: 300px;
                        height: 40px;
                        flex-grow: 0;
                        margin: 24px 0 0 0;
                        padding: 9px 14px 9px 14px;
                        border-radius: 0px;
                        border-bottom-left-radius: 6px;
                        border-top-left-radius: 6px;
                        border: none;
                        font-size: 16px;
                        &:focus {
                            border: none;
                            outline: none;
                            box-shadow: none;
                            padding: 9px 14px 9px 14px;
                            border-radius: 0px;
                            border-bottom-left-radius: 6px;
                            border-top-left-radius: 6px;
                        }
                        ::placeholder {
                            color: ${ADIColors.gray3};
                            opacity: 1;
                        }
                        ::-ms-input-placeholder {
                            color: ${ADIColors.gray3};
                        }
                    }
                }
            `,
        },
    },
    emailtextBoxTab: {
        css: css`
            width: 230px !important;
            height: 35px !important;
            flex-grow: 0;
            margin: 0px 0 0;
            padding: 8px 0px 7px 11px !important;
            background-color: ${ADIColors.white};
            color: #bbb;
            border-radius: 0px !important;
            border-bottom-left-radius: 6px !important;
            border-top-left-radius: 6px !important;
        `,
    },
    SignUpforEmail: {
        css: css`
          ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                      margin-left: 0px;
                  `,
                    css`
                      margin-left: 0px;
                  `,
                    css`
                      margin-left: 0px;
                  `,
                    null,
                    null,
                ])}
        }
        width: 184px;
        height: 30px;
        flex-grow: 0;
        margin-left: 13px;
        font-size: 22px;
        font-weight: 800;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
        `,
    },
    text1: {
        css: css`
        width: 30% !important; 
        margin-top: -50px;
        padding-right: 15px;
        margin-left: 0px !important;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    width: 100% !important;
                    margin-top: 0px !important;
                `,
                    css`
                    width: 100% !important;
                    margin-top: 0px !important;
                `,
                    css`
                    width: 0% !important;
                    padding-right: 0px;
                    margin-left: 0px !important;
                `,
                    null,
                    null,
                ])}
                @media only screen and (min-width: 1500px) {
                    margin-left: -15px !important;
                }
        }
        `,
    },
    text2: {
        css: css`
        width: 40% !important;
        margin-top: 45px;
        text-align: center;
        display: flex;
        flex-direction: row;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    width: 100% !important;
                    display: none;
                `,
                    css`
                    width: 100% !important;
                    display: none;
                `,
                    css`
                    margin-top: 60px !important;
                    display: none;
                `,
                    null,
                    css`
                    margin-top: 42px;
                `,
                ])}
        }
        `,
    },
    signUpWrapper: {
        css: css`
            display: flex;
            align-items: flex-start;
            justify-content: center;
            width: 100%;
            margin-top: 25px;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        margin-top: 0px;
                    `,
                ])}
        }
        `,
    },
    signUpTabWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            flex-direction: column;
        `,
    },
    emailTextBoxWrapper: {
        css: css`
         ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                     margin-top: 60px !important;
                 `,
                    css`
                     margin-top: 60px !important;
                 `,
                    null,
                    null,
                    null,
                ])}
            }
            display: flex;
            align-items: flex-start;
            justify-content: center;
            max-width: 420px;
            width: 100%;
        `,
    },
    emailTextBoxTabWrapper: {
        css: css`
            display: flex;
            align-items: flex-start;
            justify-content: center;
            width: 100%;
            flex-direction: row;
            margin-top: 12px;
            max-width: 330px;
            > div > div > div[class^="FormInputWrapper"] {
                margin-top: 0px !important;
            }
        `,
    },
    text3: {
        css: css`
        width: calc(100% - 120px)!important;
        margin-top: 21px !important;        
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    width: 100% !important;
                    margin-top: 10px !important;
                `,
                    css`
                    width: 100% !important;
                    margin-top: 10px !important;
                `,
                    null,
                    null,
                    null,
                ])}
        }
        `,
    },
    text4: {
        css: css`
        width: 120px !important; 
        height: 40px !important;
        flex-grow: 0 !important; 
        float: left !important;
        margin-top: 50px !important;
        padding: 7px 19.4px 5px 20px !important; 
        border: solid 1px ${ADIColors.white};
        border-left: 0px;
        border-bottom-right-radius: 6px !important; 
        border-top-right-radius: 6px !important;
        cursor: pointer;
        &:hover {
            background-color: ${ADIColors.lightGreenBg} !important;
            color: ${ADIColors.white} !important;
            > ${TypographyStyle} {
                background-color: ${ADIColors.lightGreenBg} !important;
                color: ${ADIColors.white} !important;
        }
        
        `,
    },
    textDisplay: {
        css: css`
        width: 30% !important;
        margin-top: 45px;
        text-align: center;
        max-width: 300px;
        margin-right: 0;
        margin-left: auto;
        cursor: pointer;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    width: 100% !important;
                    max-width: 100%;
                    display: flex !important;
                    flex-direction: column;
                    gap: 18px;
                `,
                    css`
                    width: 100% !important;
                    max-width: 100%;
                    display: flex !important;
                    flex-direction: column;
                    gap: 18px;
                `,
                    null,
                    null,
                    css`
                    margin-top: 40px;
                `,
                ])}
        }
        `,
    },
    text5: {
        css: css`
        width: 30% !important;
        margin-top: 68px;
        text-align: center;
        max-width: 300px;
        margin-right: 0;
        margin-left: auto;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    width: 100% !important;
                    max-width: 100%;
                    display: none;
                `,
                    css`
                    width: 100% !important;
                    max-width: 100%;
                    display: none;
                `,
                    css`
                    display: none;
                `,
                    null,
                    css`
                    margin-top: 37px;
                `,
                ])}
        }
        `,
    },
    text6: {
        css: css`
            margin-bottom: 16px;
        `,
    },
    text7: {
        css: css`
        display: flex;
        width: 100%;
        max-width: 1470px;
        margin: 0 auto;
        padding: 5px 15px 0 15px;

        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    flex-direction: column;
                    padding-bottom: 0px;
                `,
                    css`
                    flex-direction: column;
                    padding-bottom: 0px;
                `,
                    null,
                    null,
                    null,
                ])}
        }
        `,
    },
    text8: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        margin-top: 30px !important;
                    `,
                    null,
                    null,
                    css`
                        display: block;
                        margin-top: -30px;
                    `,
                    null,
                ]);
            }}
            position: absolute;
            padding-right: 8%;
        `,
    },
    text9: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ]);
            }}
            width: 34px;
            height: 30px;
            margin-left: 20px;
            float: inline-start;
            object-fit: none;
        `,
    },
    branchIocn: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ]);
            }}
            width: 34px;
            height: 32px;
        `,
    },
    text10: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ]);
            }}
            width: 34px;
            height: 37px;
            object-fit: none;
        `,
    },
    text11: {
        css: css`
            width: 100% !important;
            height: 270px !important;
            max-width: 340px;
            margin-top: 20px;
            object-fit: contain;
            @media only screen and (min-width: 1081px) and (max-width: 1500px) {
                width: auto !important;
                margin-left: 0px !important;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    css`
                        margin-top: 0px;
                        padding-left: 0px;
                        margin-left: 0px !important;
                    `,
                ]);
            }}
        `,
    },
    vectorMessage: {
        css: css`
            width: 34px;
            height: 25px;
            background-color: #51d4d9;
        `,
    },
    vectorChat: {
        css: css`
            width: 34px;
            height: 31.5px;
            padding: 10.8px 8.3px 17.4px 9.1px;
            border: solid 0.1px #51d4d9;
            background-color: #51d4d9;
        `,
    },
    needAssistance: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ]);
            }}
            flex-grow: 0;
            font-size: 22px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #fff;
            margin-left: 13px;
            padding-bottom: 10px;
            margin-top: 5px;
        `,
    },
    downloadchatwithusTab: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        width: 162px;
                        font-size: 16px !important;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ]);
            }}
            width: 182px;
            height: 30px;
            flex-grow: 0;
            // margin: 6px 39px 20px 15px;
            font-size: 22px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #fff;
        `,
    },
    downloadchatwithus: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        width: 162px;
                        font-size: 16px !important;
                    `,
                    null,
                    css`
                        width: 162px;
                        font-size: 16px !important;
                    `,
                    null,
                    null,
                ]);
            }}
            width: 182px;
            height: 30px;
            flex-grow: 0;
            // margin: 6px 39px 20px 15px;
            font-size: 22px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #fff;
        `,
    },
    mondayTofridayText: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`color: ${ADIColors.gray6}; margin-left: -168px; !important; margin-top: -53px;`,
                    css`color: ${ADIColors.gray6}; margin-left: -168px; !important; margin-top: -53px;`,
                    css`
                        display: none !important;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    mobileIcons: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        height: 30px !important;
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ]);
            }}
        `,
    },
    outlineButton: {
        css: css`
            width: 300px;
            height: 40px;
            flex-grow: 0;
            padding: 7px 100px;
            border-radius: 6px;
            border: solid 1px #fff;
            cursor: pointer;
            display: block;
            &:hover {
                background-color: ${ADIColors.lightGreenBg} !important;
                color: ${ADIColors.white} !important;
                > ${TypographyStyle} {
                    background-color: ${ADIColors.lightGreenBg} !important;
                    color: ${ADIColors.white} !important;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        border: none;
                    `,
                    css`
                        border: none;
                    `,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },
    signUpText: {
        css: css`
            width: 80.6px;
            height: 30px;
            flex-grow: 0;
            font-family: NunitoSans;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #fff;
            cursor: pointer;
        `,
    },
    signupButton: {
        css: css`
            cursor: pointer;
            width: 174.1px;
            height: 30px;
            flex-grow: 0;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #fff !important;
        `,
    },
    chatWithUs: {
        css: css`
            cursor: pointer;

            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ]);
            }},
            width: 174.1px;
            height: 30px;
            flex-grow: 0;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #fff !important;
        `,
    },
    chatWithUsTab: {
        css: css`
            font-size: 16px;
            font-weight: normal;
            line-height: normal;
            text-align: center;
            color: ${ADIColors.white};
        `,
    },
    needAssistanceBottomText: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ]);
            }},
            width: 221px;
            height: 19px;
            flex-grow: 0;
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #f7f7f7;
        `,
    },

    footerBarContainer: {
        css: css`
            max-width: 100%;
            background-color: #0c2239;
            > ${GridWrapper} {
                margin: 0px auto;
                padding: 0 15px;
                max-width: 1470px;
                width: 100%;
                ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                            padding-top: 0px;
                            max-width: 100%;
                        `,
                    css`
                            padding-top: 0px;
                            max-width: 100%;
                        `,
                    null,
                    null,
                    css`
                            margin: 0 auto !important;
                        `,
                ]);
            }},

                >${GridOffset} {
                    width: 100%;
                    margin: 0px;
                    ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                            `,
                    null,
                    null,
                ]);
            }},
                    >${GridItemStyle} {
                        ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                                    padding-bottom: 0px;
                                    padding-left: 0px;
                                    padding-right: 0px;
                                `,
                    css`
                                    padding-bottom: 0px;
                                    padding-left: 0px;
                                    padding-right: 0px;
                                `,
                    css`
                                    max-width: 100%;
                                `,
                    css`
                                    padding-left: 0px;
                                    padding-right: 0px;
                                `,
                    css`
                                    padding-left: 0px;
                                    padding-right: 0px;
                                `,
                ]);
            }},
                    }

                    div[data-test-selector="copyrightFooterLinks"] > div {
                        ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                                    display: flex;
                                    justify-content: center;
                                    margin-top: 0px !important;
                                    .title-wrapper {
                                        flex: 1 1 100%;
                                        text-align: center;
                                    }
                                    .copyrightLinksWrapper > button {
                                        margin: 0px;
                                    }
                                    .copyrightLinksWrapper > a > span {
                                        margin: 0px 5px 0px;
                                    }
                                `,
                    css`
                                    display: flex;
                                    justify-content: center;
                                    margin-top: 0px !important;
                                    .title-wrapper {
                                        flex: 1 1 100%;
                                        text-align: center;
                                    }
                                    .copyrightLinksWrapper > button {
                                        margin: 0px;
                                    }
                                    .copyrightLinksWrapper > a > span {
                                        margin: 0px 5px 0px;
                                    }
                                `,
                    css`
                                    display: flex;
                                    justify-content: center;
                                    .title-wrapper {
                                        flex: 1 1 100%;
                                        text-align: center;
                                    }
                                `,
                    null,
                    null,
                ]);
            }},
                    }
                }
                .copyright {
                    padding: 20px 0px 5px;
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                    text-align: center;
                                `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
                    p {
                        color: ${getColor("common.background")};
                        a {
                            &:hover {
                                font-weight: bold;
                            }
                            span {
                                color: ${getColor("common.background")};
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }
        `,
    },
    container: {
        gap: 20,
        css: css`
            > ${GridOffset} {
                justify-content: center;
                > ${GridItemStyle} {
                    &:last-child {
                        padding: 0px;
                    }
                }
            }
        `,
    },
    linksGridContainer: {
        width: [12, 12, 7, 7, 8],
    },
    iconsGridContainer: {
        width: [12, 12, 5, 5, 4],
    },

    tabContainer: {
        css: css`
            display: flex;
            width: 100%;
            margin-top: 35px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        margin-top: 33px;
                    `,
                    css`
                        flex-direction: column;
                        margin-top: 33px;
                    `,
                    null,
                    null,
                    null,
                ]);
            }},
        `,
    },
    tabLeftContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 50%;
            margin-top: 15px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        margin-top: 0px;
                    `,
                    css`
                        width: 100%;
                        margin-top: 0px;
                    `,
                    null,
                    null,
                    null,
                ]);
            }},
        `,
    },
    tabRightContainer: {
        css: css`
            display: flex;
            flex-direction: row;
            width: 50%;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        margin-top: 42px;
                        margin-bottom: 6px;
                    `,
                    css`
                        width: 100%;
                        margin-top: 42px;
                        margin-bottom: 6px;
                    `,
                    null,
                    null,
                    null,
                ]);
            }},
        `,
    },
    signupTextTab: {
        css: css`
            min-width: 100px !important;
            height: 35px !important;
            flex-grow: 0 !important;
            float: left !important;
            margin-top: 0px !important;
            padding: 5px 16px 5px 16px !important;
            border: solid 1px ${ADIColors.white} !important;
            border-bottom-right-radius: 6px !important;
            border-top-right-radius: 6px !important;
            text-align: center;
        `,
    },
    tabBranchlocContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            padding: 0px 12px;
            width: calc(100% / 3);
            > span {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        `,
    },
    tabDownloadAppContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            padding: 0px 12px;
            width: calc(100% / 3);
            position: relative;
            &:after {
                content: "";
                height: calc(100% - 35px);
                width: 1px;
                position: absolute;
                right: 0px;
                top: 0;
                background-color: #ffffff30;
            }
            &:before {
                content: "";
                height: calc(100% - 35px);
                width: 1px;
                position: absolute;
                left: 0px;
                top: 0;
                background-color: #ffffff30;
            }
        `,
    },
    tabChatWithUsContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            padding: 0px 12px;
            width: calc(100% / 3);
            > span:first-child {
                padding: 0px 0px;
            }
            > span {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        `,
    },
    tabfootertext: {
        css: css`
            font-size: 16px;
            font-weight: 800;
            line-height: 1.25;
            letter-spacing: normal;
            text-align: center;
            color: #fff !important;
            margin-bottom: 7px;
            > span {
                color: #fff !important;
            }
        `,
    },
    tabfooterchattext: {
        css: css`
            font-size: 10px;
            color: ${ADIColors.gray6};
            font-weight: 600;
            margin-top: 10px;
            text-align: center;
            padding: 0px 00px;
        `,
    },
    emailErrorText: {
        css: css`
            font-size: 16px;
            color: ${ADIColors.errorFields};
            font-weight: bold;
            margin-top: 7px;
            text-align: center;
            display: flex;
            justify-content: flex-start;
        `,
    },
};

const styles = adiFooterBarStyles;
const isUSRegion = typeof window !== 'undefined' && window.location.hostname.endsWith('.us');
const ADIFooterBar: FC<Props> = ({
    id,
    liveChatURL,
    deviceType,
    isAuthenticated,
    livechat_firstName,
    livechat_lastName,
    livechat_accountNumber,
    livechat_email,
    toggleLoginDrawer,
}) => {
    const History = useHistory();
    const [email, setEmail] = useState<string>("");
    const [error, setError] = useState("");

    useEffect(() => {
        const liveChat = localStorage.getItem("openLiveChat");
        if (liveChat === "true" && livechat_accountNumber !== undefined) {
            handleChat();
        }
    }, [livechat_accountNumber]);

    const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setEmail(value);
    };

    const handleSignUp = () => {
        if (!email) {
            setError("Email is required");
        } else if (!isValidEmail(email)) {
            setError("Please enter a valid email");
        } else {
            setError("");
            window.open("https://go.adiglobal.com/NA-email-sign-up.html", "_blank");
        }
    };

    const isValidEmail = (email: string) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };

    const handleChat = () => {
        if (isAuthenticated) {
            const popup: string = "popUpWindow";
            const popupParam: string =
                "height=551,width=344,left=100,top=100,resizable=false,scrollbars=false,toolbar=false,menubar=no,location=no,directories=no,status=yes";

            if (liveChatURL) {
                const result =
                    liveChatURL +
                    "firstName=" +
                    livechat_firstName +
                    "&lastName=" +
                    livechat_lastName +
                    "&accountNumber=" +
                    livechat_accountNumber?.toString().replace("-", "") +
                    "&email=" +
                    livechat_email;
                window.open(result, popup, popupParam);
                localStorage.setItem("openLiveChat", "false");
            }
        } else {
            localStorage.setItem("openLiveChat", "true");
            toggleLoginDrawer({ loginDrawer: true });
        }
    };

    const handleDownload = () => {
        const isIphone = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (isIphone) {
            window?.open("https://play.google.com/store/apps/details?id=com.adi.ecom.us.prd", "_blank"); // Apple App Store link for games
        } else {
            window?.open("https://play.google.com/store/apps/details?id=com.adi.ecom.us.prd", "_blank"); // Google Play Store link
        }
    };
    const handleBranchLocator = () => {
        History.push("/dealerlocator");
    };
    const [isTab, setIsTab] = React.useState(false);
    React.useEffect(() => {
        if (typeof window !== "undefined") {
            if (window.innerWidth <= 1080) {
                setIsTab(true);
            } else {
                setIsTab(false);
            }
        }
        const onWindowResize = () => {
            if (window.innerWidth <= 1080) {
                setIsTab(true);
            } else {
                setIsTab(false);
            }
        };
        onWindowResize();

        if (typeof window !== "undefined") {
            window.addEventListener("resize", onWindowResize);
        }

        return () => {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", onWindowResize);
            }
        };
    }, []);

    return (
        <StyledWrapper {...styles.footerBarContainer}>
            <StyledWrapper {...styles.text7}>
                {isUSRegion ? (
                    <Typography as="div" {...styles.text1}>
                        <Img
                            {...styles.text11}
                            src="https://adiglobaldistribution.us/UserFiles/US/userfiles/Images/footer/Mobile-App-Section.svg"
                        />
                    </Typography>
                ) : null}
                <Typography as="div" {...styles.text2}>
                    <StyledWrapper {...styles.signUpWrapper}>
                        <Typography as="div" {...styles.text8}>
                            <Typography as="span">
                                <Img
                                    {...styles.text9}
                                    src="https://adiglobaldistribution.us/UserFiles/US/userfiles/Images/footer/email-footer.svg"
                                />
                                <Typography as="span" {...styles.SignUpforEmail}>
                                    Sign Up for Email
                                </Typography>
                            </Typography>
                        </Typography>
                        <StyledWrapper {...styles.emailTextBoxWrapper}>
                            <Typography as="div" {...styles.text3}>
                                <TextField
                                    {...styles.footerImages}
                                    placeholder={translate("Email Address")}
                                    type="email"
                                    name="email"
                                    value={email}
                                    onChange={handleChangeEmail}
                                />
                                {error && <Typography {...styles.emailErrorText}>{error}</Typography>}
                            </Typography>
                            <Typography
                                as="div"
                                tabIndex={0}
                                {...styles.text4}
                                onClick={handleSignUp}
                                onKeyDown={(e: any) => (e.key === "Enter" || e.key === " ") && handleSignUp()}
                            >
                                <Typography as="span" {...styles.signupButton}>
                                    Sign Up
                                </Typography>
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </Typography>

                {isTab ? (
                    <StyledWrapper {...styles.tabContainer}>
                        <StyledWrapper {...styles.tabLeftContainer}>
                            <StyledWrapper {...styles.signUpTabWrapper}>
                                <Typography as="div">
                                    <Typography as="span" {...styles.SignUpforEmail}>
                                        Sign Up for Email
                                    </Typography>
                                </Typography>

                                <StyledWrapper {...styles.emailTextBoxTabWrapper}>
                                    <Typography as="div">
                                        <TextField
                                            {...styles.emailtextBoxTab}
                                            placeholder={translate("Email Address")}
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={handleChangeEmail}
                                        />
                                        {error && <Typography {...styles.emailErrorText}>{error}</Typography>}
                                    </Typography>
                                    {isUSRegion ? (
                                        <Typography as="div" {...styles.signupTextTab} onClick={handleSignUp}>
                                            <Typography as="span" {...styles.chatWithUsTab}>
                                                Sign Up
                                            </Typography>
                                        </Typography>
                                    ) : null}
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.tabRightContainer}>
                            <StyledWrapper {...styles.tabBranchlocContainer}>
                                <Typography {...styles.tabfootertext}>
                                    <Link href="/dealerlocator" {...styles.tabfootertext}>
                                        {translate("Branch")}
                                        <br />
                                        {translate("Locator")}
                                    </Link>
                                    <Link href="/dealerlocator">
                                        <FooterBranchIcon />
                                    </Link>
                                </Typography>
                            </StyledWrapper>
                            {isUSRegion ? (
                                <StyledWrapper {...styles.tabDownloadAppContainer} onClick={handleDownload}>
                                    <Typography {...styles.tabfootertext}>
                                        {translate("Download")}
                                        <br />
                                        {translate("Mobile App")}
                                    </Typography>
                                    <FooterAppIcon />
                                </StyledWrapper>) : null}
                            {isUSRegion ? (
                                <StyledWrapper {...styles.tabChatWithUsContainer}>
                                    <Typography {...styles.tabfootertext} onClick={handleChat}>
                                        {translate("Chat")}
                                        <br />
                                        {translate("With Us")}
                                        <FooterChatIcon />
                                    </Typography>

                                    <Typography {...styles.tabfooterchattext}>
                                        {translate("Monday to Friday ")}
                                        <br />
                                        {translate("8am to 7pm EST")}
                                    </Typography>
                                </StyledWrapper>) : null}
                        </StyledWrapper>
                    </StyledWrapper>
                ) : null}
                <StyledWrapper {...styles.mobileIcons}>
                    <div>
                        <Typography as="div" {...styles.textDisplay} onClick={handleBranchLocator}>
                            <Typography as="span" {...styles.downloadchatwithus}>
                                Branch <br />
                                Locator
                            </Typography>
                            <Img
                                onClick={handleBranchLocator}
                                {...styles.branchIocn}
                                src="https://adiglobaldistribution.us/UserFiles/US/userfiles/Images/footer/branch-footer.svg"
                            />
                            <br />
                        </Typography>
                    </div>
                    <div>
                        {isUSRegion ? (
                            <Typography as="div" {...styles.textDisplay}>
                                <Typography as="span" {...styles.downloadchatwithusTab}>
                                    Download <br />
                                    Mobile App
                                </Typography>
                                <Img
                                    {...styles.branchIocn}
                                    src="https://adiglobaldistribution.us/UserFiles/US/userfiles/Images/footer/app-footer.svg"
                                />
                                <br />
                            </Typography>
                        ) : null}
                    </div>
                    <div>
                        {isUSRegion ? (
                            <Typography as="div" {...styles.textDisplay}>
                                <Typography as="span" {...styles.downloadchatwithus} onClick={handleChat}>
                                    Chat <br />
                                    with us
                                </Typography>
                                <Img
                                    onClick={handleChat}
                                    {...styles.branchIocn}
                                    src="https://adiglobaldistribution.us/UserFiles/US/userfiles/Images/footer/chat-footer.svg"
                                />
                                <br />
                                <Typography as="span" {...styles.mondayTofridayText}>
                                    Monday to Friday
                                    <br /> 8am to 7pm EST
                                </Typography>
                            </Typography>
                        ) : null}
                    </div>
                </StyledWrapper>
                {isUSRegion ? (
                    <Typography as="div" {...styles.text5}>
                        <Typography style={{ display: "flex", paddingLeft: "8%", marginBottom: "10px" }}>
                            <Img
                                {...styles.text10}
                                src="https://adiglobaldistribution.us/UserFiles/US/userfiles/Images/footer/chat-footer.svg"
                            />
                            <Typography as="span" {...styles.needAssistance}>
                                Need Assistance?
                            </Typography>
                        </Typography>
                        <Typography as="div" {...styles.text6}>
                            <Typography as="span" {...styles.outlineButton} onClick={handleChat}>
                                <Typography
                                    tabIndex={0}
                                    {...styles.chatWithUs}
                                    onClick={handleChat}
                                    onKeyDown={(e: any) => (e.key === "Enter" || e.key === " ") && handleChat()}
                                >
                                    Chat with Us
                                </Typography>
                            </Typography>
                        </Typography>
                        <Typography as="span" {...styles.needAssistanceBottomText}>
                            Monday to Friday 8am to 7pm EST
                        </Typography>
                    </Typography>) : null}
            </StyledWrapper>
            <GridContainer {...styles.container}>
                <GridItem {...styles.linksGridContainer}>
                    <Zone contentId={id} zoneName="linksZone" />
                </GridItem>
                <GridItem {...styles.iconsGridContainer}>
                    <Zone contentId={id} zoneName="iconsZone" />
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIFooterBar),
    definition: {
        group: "Basic",
        displayName: "ADI Footer Bar",
    },
};

export default widgetModule;
